<template>
  <form v-on:submit="submit" id="editUserForm" novalidate>
    <div class="form-row">
      <div class="col-md-6 mb-3">
        <base-input
          label="User Name"
          :value="user.name"
          input-classes="form-control-alternative"
          readonly
        />
      </div>
      <div class="col-md-6 mb-3">
        <base-input
          label="User Email"
          :value="user.email"
          input-classes="form-control-alternative"
          readonly
        />
      </div>
    </div>
    <div class="form-group">
      <label>Roles</label>
      <v-select
        :options="roleOptions"
        :multiple="true"
        :close-on-select="false"
        v-model="selectedRoles"
        placeholder="Click to select roles"
        label="roles"
      />
    </div>

    <button class="btn btn-primary" type="submit">Update user</button>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

export default {
  name: "enrollpotentialeeform",
  props: {
    user: null
  },
  data() {
    return {
      roleOptions: [
        "enrollUser",
        "userRead",
        "userUpdate",
        "roleRead",
        "roleChange",
        "potentialeeChange",
        "enrollPotentialee",
        "jobChange",
        "createJob",
        "deleteJob",
        "resourceChange",
        "createResource",
        "deleteResource",
        "deletePotentialee",
      ],
      selectedRoles: []
    };
  },
  watch: {
    user(newUser, _) {
      this.getPreselectedRoles();
    }
  },
  methods: {
    getPreselectedRoles() {
      const curOrgId = this.$store.state.usermain.curOrg.id;
      const self = this;

      firebase
        .firestore()
        .doc("organizations/" + curOrgId + "/roles/" + self.user.id)
        .get()
        .then(function(rolesDoc) {
          const rolesData = rolesDoc.data();

          self.selectedRoles = Object.keys(rolesData);
        });
    },
    submit: function(event) {
      const form = document.getElementById("editUserForm");

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");
      
      if (form.checkValidity()) {
        const curOrgId = this.$store.state.usermain.curOrg.id;

        let selectedRolesMap = this.selectedRoles.reduce((a,b)=> (a[b]=true,a),{});

        firebase
          .firestore()
          .doc("organizations/" + curOrgId + "/roles/" + this.user.id)
          .set(selectedRolesMap)
          .then(ref => {
            $("#editUser").modal("hide");
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    }
  }
};
</script>

<style scoped>
</style>
